import { trackEvent } from "infra/helpers/event";
import create from "zustand";
import { persist } from "zustand/middleware";
import { TenantMeResponse } from "./typings/user";

interface TenantStore {
  tenant: TenantMeResponse;
  updateCurrentTenant: (tenant: TenantMeResponse) => void;
  selecionar: (tenant: TenantMeResponse) => void;
  reset: () => void;
}

export const useCurrentTenant = create<TenantStore>(
  persist(
    (set) => ({
      tenant: {} as TenantMeResponse,
      updateCurrentTenant: (tenant: TenantMeResponse) => {
        set((state) => ({ ...state, tenant }));
      },
      selecionar: (tenant: TenantMeResponse) => {
        trackEvent("TenantSelecionado", {
          id: tenant.id,
          nome: tenant.nome,
        });

        set((state) => ({ ...state, tenant }));
      },
      reset: () => {
        set((state) => ({ ...state, tenant: {} as TenantMeResponse }));
      },
    }),
    {
      name: "@administradora-digital-tenant",
      getStorage: () => localStorage,
    }
  )
);
